import { useQuery } from "@tanstack/react-query"
import { makeDownloadDocument } from "../../domain/use-cases/download-document"
import { httpDocumentRepository } from "../../data/repositories/document-repository"

const getFile = makeDownloadDocument(httpDocumentRepository)

export const useDocumentFile = (docId: string | null) =>
  useQuery({
    queryKey: ["document-file", docId],
    enabled: !!docId,
    queryFn: () => getFile(docId as string),
    staleTime: Infinity,
  })
